module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'facts' + (_vm.small ? ' small' : '')
  }, [_c('div', {
    class: 'fact ' + (_vm.unit.bedrooms ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "antal rum",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sovrum (" + _vm._s(_vm.unit.bedrooms) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.bedrooms))])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.living_area ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "area",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Boarea (" + _vm._s(_vm.unit.living_area) + "m"), _c('sup', [_vm._v("2")]), _vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v(_vm._s(_vm.unit.living_area) + "m"), _c('sup', [_vm._v("2")])])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.internet ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "wifi",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Wi-Fi")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.washing_machine ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "tvattmaskin-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tvättmaskin")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.terrace_balcony ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "balkong",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Balkong/altan")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.dishwasher ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "diskmaskin-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Diskmaskin")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.pets_allowed ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "husdjur-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Husdjur tillåtna")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.sauna ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "bastu-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bastu")])], 1), _vm._v(" "), (!_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    class: 'fact ' + 'active'
  }, [_c('icon', {
    attrs: {
      "name": "direkt-incheck-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.unit.direct_incheck ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[1].title : _vm.SITE_CONFIG.settings.SettingLockTypes.texts[0].title))])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.settings.SettingLockTypes.active) ? _c('div', {
    class: 'fact ' + (_vm.unit.lock_type_id ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "direkt-incheck-black",
      "scale": 1.6
    }
  }), _vm._v("\n      " + _vm._s(_vm.unit.lock_type_id ? _vm.SITE_CONFIG.settings.SettingLockTypes.texts[_vm.unit.lock_type_id].title : Object.values(_vm.SITE_CONFIG.settings.SettingLockTypes.texts).map(function(item) {
    return item.title;
  }).join(' / ')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.handicap_rooms ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "handikapp",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Handikappanpassat")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.dryer_cabinet ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "torkskap",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Torkskåp")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.toilets ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "wc",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("WC (" + _vm._s(_vm.unit.toilets) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.toilets))])], 1), _vm._v(" "), (_vm.SITE_CONFIG.site != 'branas') ? _c('div', {
    class: 'fact ' + (_vm.unit.hot_tub ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "badtunna",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Badtunna")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.extra_beds ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "sangar",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extrabäddar (" + _vm._s(_vm.unit.extra_beds) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.extra_beds))])], 1), _vm._v(" "), (_vm.unit.final_cleaning_included && !_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + 'active'
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Slutstäd (ingår)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("Ingår")])], 1) : _vm._e(), _vm._v(" "), (!_vm.unit.final_cleaning_included && !_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + (_vm.unit.final_cleaning_available ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Slutstäd (tillval)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("Tillval")])], 1) : _vm._e(), _vm._v(" "), (_vm.unit.has_mandatory_cleaning) ? _c('div', {
    class: 'fact ' + (_vm.unit.final_cleaning_available ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "stadning-black",
      "scale": 1.6
    }
  }), _vm._v("\n      Slutstäd (obligatoriskt)\n    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.child_friendly ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "smiley-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extra barnanpassat")])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.beds ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "sangar",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bäddar (" + _vm._s(_vm.unit.beds) + "st)")]), _vm._v(" "), _c('span', {
    staticClass: "hard-fact"
  }, [_vm._v("x" + _vm._s(_vm.unit.beds))])], 1), _vm._v(" "), _c('div', {
    class: 'fact ' + (_vm.unit.fireplace ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "kamin-sv",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Öppen spis")])], 1), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.filters.chargeStation) ? _c('div', {
    class: 'fact ' + (_vm.unit.charging_post ? 'active' : '')
  }, [_c('icon', {
    attrs: {
      "name": "laddstolpe-black",
      "scale": 1.6
    }
  }), _vm._v(" "), _c('span', [_vm._v("Laddstolpe")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (!_vm.small && _vm.unit.pool.map_link) ? _c('a', {
    staticClass: "button white small border map-bt",
    attrs: {
      "target": "_blank",
      "href": _vm.unit.pool.map_link
    }
  }, [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 2
    }
  }), _vm._v(" Se områdeskarta\n    "), _c('icon', {
    staticClass: "dowload-icon",
    attrs: {
      "name": "download",
      "scale": 1.5
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.small) ? _c('div', {
    staticClass: "facts special-fact"
  }, [_c('div', {
    staticClass: "fact active"
  }, [_c('icon', {
    attrs: {
      "name": "avstand-lift",
      "scale": 1.7
    }
  }), _vm._v(" "), _c('b', [_vm._v("Avstånd pist:")]), _vm._v(" " + _vm._s(_vm.unit.distance_to_pist) + "m\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "fact active"
  }, [_c('icon', {
    attrs: {
      "name": "gondol-lift",
      "scale": 1.7
    }
  }), _vm._v(" "), _c('b', [_vm._v("Avstånd lift:")]), _vm._v(" " + _vm._s(_vm.unit.distance_to_skilift) + "m\n    ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.small && (_vm.unit.check_in_time || _vm.unit.check_out_time)) ? _c('div', {
    staticClass: "facts special-fact"
  }, [_c('div', {
    staticClass: "fact active",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b', [_vm._v("Incheckning:")]), _vm._v(" " + _vm._s(_vm.unit.check_in_time) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "fact active",
    staticStyle: {
      "width": "100%",
      "padding-top": "0"
    }
  }, [_c('b', [_vm._v("Utcheckning:")]), _vm._v(" " + _vm._s(_vm.unit.check_out_time) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2006)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "berget",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Berget")]), _vm._v(" "), _c('p', [_vm._v("I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2007)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "byn",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Dalen")]), _vm._v(" "), _c('p', [_vm._v("I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.")])], 1) : _vm._e(), _vm._v(" "), (!_vm.small && _vm.SITE_CONFIG.accomodations.show_site && (_vm.unit.facility && _vm.unit.facility.id === 2020)) ? _c('div', {
    staticClass: "facility-area"
  }, [_c('icon', {
    attrs: {
      "name": "mattesdalen",
      "scale": 2.25
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Mattesdalen")]), _vm._v(" "), _c('p', [_vm._v("I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5520a7e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/UnitFacts.vue
// module id = 976
// module chunks = 0